import styled from "styled-components";

export const CartTital = styled.h1`

font-weight:bold;
font-family: 'Shadows Into Light', cursive;
`

export const TableTh =styled.th`
font-size: 20px;
  text-align: center;
font-family: 'Asap', sans-serif;
`
export const TableTr =styled.tr`
font-size: 20px;
  text-align: center;
font-family: 'Indie Flower', cursive;
`
export const TableDate =styled.h4`
font-family: 'Indie Flower', cursive;
font-weight:bold;
`
export const CartImg = styled.img`
height: 45px;
width: 45px;
`
export const CartRowheight = styled.td`
font-family: 'Asap', sans-serif;
font-size: 20px;
text-align: end !important;
`



export const ThankYou = styled.div`
text-align: center
background-repeat: no-repeat;
 background-image: url('images/backgrounds/background7.png');
background-size: cover;
 background-position: center;
 font-size: 60px;
 font-family: 'Shadows Into Light', cursive;
 font-weight:bold;
color:white;
 padding-top:15%;
 padding-bottom:15%;
`